import { render, staticRenderFns } from "./ImprovementMeasuresManage.vue?vue&type=template&id=65638b62&"
import script from "./ImprovementMeasuresManage.vue?vue&type=script&lang=js&"
export * from "./ImprovementMeasuresManage.vue?vue&type=script&lang=js&"
import style0 from "./ImprovementMeasuresManage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports